export default "__VITE_ASSET__DTT31Qo0__"